import { useSelector } from 'react-redux'
import { css } from 'styled-components'

import { FLOATING_TRANSITION_DURATION } from '@constants/theme'

import { SUPPORT_LAUNCHER } from './constants'

const OFFSCREEN_TRANSFORM = 'translateX(calc(100% + 100px))'
// HubSpot's bubble takes the corner itself, so the envelope rests one launcher to the left of it
const BESIDE_CHAT_LAUNCHER = `translateX(-${SUPPORT_LAUNCHER.size + SUPPORT_LAUNCHER.gap}px)`

export function useIsSupportSlideOverOpen() {
  return useSelector((state: Store) => state.messageToAccountant.isSlideOverOpen)
}

interface LauncherVisibilityProps {
  $hasChatLauncher?: boolean
  $isHidden: boolean
}

export function getLauncherVisibilityStyles({ $hasChatLauncher = false, $isHidden }: LauncherVisibilityProps) {
  return css`
    transform: ${$hasChatLauncher ? BESIDE_CHAT_LAUNCHER : 'none'};
    transition:
      transform ${FLOATING_TRANSITION_DURATION}ms ease-in-out,
      visibility 0s;

    ${$isHidden &&
    css`
      transform: ${OFFSCREEN_TRANSFORM};
      visibility: hidden;
      pointer-events: none;
      transition:
        transform ${FLOATING_TRANSITION_DURATION}ms ease-in-out,
        visibility 0s linear ${FLOATING_TRANSITION_DURATION}ms;
    `}

    @media (prefers-reduced-motion: reduce) {
      transition: none;
    }
  `
}
